module.exports = __webpack_public_path__ + "assets/events_travel_plain.abbcf595.svg";